export default __webpack_public_path__ + "static/media/migration_friendly.54ba56d5.png";